var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.815 4.317l7.114 7.092a.745.745 0 01.18.274.914.914 0 01.052.317.941.941 0 01-.052.317.731.731 0 01-.18.274l-7.114 7.114a1.002 1.002 0 01-.738.295c-.296 0-.55-.105-.76-.317A1.013 1.013 0 017 18.945c0-.282.106-.528.317-.74L13.523 12 7.317 5.794a.99.99 0 01-.296-.728c0-.29.106-.539.317-.75.211-.21.457-.316.739-.316.281 0 .527.106.738.317z",
    fill: "currentColor"
  })));
}
export default SvgChevronRight;